import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BaseService } from '@library-shared/base/base.service';
import { ApiRecordsReturn } from '@library-shared/models/api-records-return';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class extMail_Out_Document_Validate_Pin_Request {
    public constructor(init?: Partial<extMail_Out_Document_Validate_Pin_Request>) {
        Object.assign(this, init);
    }

    mail_out_document_number: string;
    pin: string;
}

export class extMail_Out_Document_Validate_Pin_Response {
    public constructor(init?: Partial<extMail_Out_Document_Validate_Pin_Response>) {
        Object.assign(this, init);
    }

    mail_out_id: string;
    mail_out_document_id: string;
    pbm_id: string;
    mail_out_document_number: string;
    pin: string;
}

@Injectable({
    providedIn: 'root',
})
export class PleaService extends BaseService {
    private apiURL = environment.apiURL + '/api/plea';

    Mail_Out_Document_Validate_Pin(
        req: extMail_Out_Document_Validate_Pin_Request
    ): Observable<ApiRecordsReturn<extMail_Out_Document_Validate_Pin_Response>> {
        const url = `${this.apiURL}/Mail_Out_Document_Validate_Pin`;
        return this.http
            .post<ApiRecordsReturn<extMail_Out_Document_Validate_Pin_Response>>(url, req, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }
}
